// Keeps the cart count bubble pulsing continuously whenever there's at least
// one item in the cart, per conversion-rate optimization.
function sinobSyncCartPulse(count) {
  document.querySelectorAll('cart-count.count-bubble').forEach((el) => {
    el.classList.toggle('cart-pulse', count > 0);
  });
}

document.addEventListener('cart:change', (event) => {
  sinobSyncCartPulse(event.detail['cart']['item_count']);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('cart-count.count-bubble').forEach((el) => {
    const count = parseInt(el.textContent.trim(), 10);
    sinobSyncCartPulse(Number.isNaN(count) ? 0 : count);
  });
});
